import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import classNames from 'classnames'
import { useSalesDocumentShortcuts } from '@/hooks/useSalesDocumentShortcuts'
import Sidebar from './Sidebar'
import Header from './Header'
import Footer from './Footer'

/**
 * Main layout wrapper with sidebar, header, and footer
 */
const Layout = () => {
  useSalesDocumentShortcuts()
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed)
  }

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  return (
    <div className="layout-container">
      {/* Sidebar */}
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        onToggle={toggleSidebar}
        isMobileMenuOpen={isMobileMenuOpen}
        onMobileMenuClose={closeMobileMenu}
      />

      {/* Header */}
      <Header
        onMobileMenuToggle={toggleMobileMenu}
        isCollapsed={isSidebarCollapsed}
      />

      {/* Main content */}
      <main
        id="main-content"
        className={classNames(
          'pt-16 min-h-screen transition-all duration-300',
          {
            'lg:ml-64': !isSidebarCollapsed,
            'lg:ml-20': isSidebarCollapsed,
          }
        )}
      >
        <div className="p-4 sm:p-6 lg:p-8">
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default Layout


